import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 2,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "m-2" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = {
  key: 0,
  class: "col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
}
const _hoisted_9 = { class: "col-12 col-md-6" }
const _hoisted_10 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_11 = { class: "form-group mb-0" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_14 = {
  key: 1,
  class: "text-info"
}
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_17 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_18 = { key: 6 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 7 }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0" }
const _hoisted_24 = { class: "col-12 col-md-6" }
const _hoisted_25 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_26 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_27 = { class: "m-2" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = {
  key: 0,
  class: "col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
}
const _hoisted_30 = { class: "col-12 col-md-6" }
const _hoisted_31 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_32 = { class: "form-group mb-0" }
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_35 = {
  key: 1,
  class: "text-info"
}
const _hoisted_36 = { key: 2 }
const _hoisted_37 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_38 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_39 = { key: 6 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { key: 7 }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0" }
const _hoisted_45 = { class: "col-12 col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaymentReceipts = _resolveComponent("PaymentReceipts")!
  const _component_PaymentRefunds = _resolveComponent("PaymentRefunds")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.paimentNote.note_ref), 1),
        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("h5", null, [
          _cache[12] || (_cache[12] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.paimentNote.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(_ctx.getDate(_ctx.paimentNote.created_at)), 1))
            : _createCommentVNode("", true),
          _cache[13] || (_cache[13] = _createTextVNode(" | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.paimentNote.zone_name), 1),
          _cache[14] || (_cache[14] = _createTextVNode(" | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.paimentNote.agency_name), 1),
          _cache[15] || (_cache[15] = _createTextVNode(" | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.paimentNote.for_name), 1)
        ])
      ])
    ]),
    (_ctx.paimentNote.id && _ctx.paimentNote.statut == 2)
      ? (_openBlock(), _createBlock(_component_PaymentReceipts, {
          key: 0,
          "note-id": _ctx.paimentNote.id,
          "can-upload": _ctx.user?.role_id == 4
        }, null, 8, ["note-id", "can-upload"]))
      : _createCommentVNode("", true),
    (_ctx.paimentNote.id)
      ? (_openBlock(), _createBlock(_component_PaymentRefunds, {
          key: 1,
          "note-id": _ctx.paimentNote.id
        }, null, 8, ["note-id"]))
      : _createCommentVNode("", true),
    (_ctx.paimentNote.statut == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "card-header pb-2" }, [
            _createElementVNode("h5", null, "List des nouveaux colis")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.auth.can('ADD_BP_L'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", null, "Voir", -1)),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.users.per_page,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.users.per_page) = $event)),
                          _cache[1] || (_cache[1] = ($event: any) => (_ctx.getRows1()))
                        ],
                        options: [10, 25, 50, 100],
                        clearable: false,
                        class: "per-page-selector d-inline-block mx-50"
                      }, null, 8, ["modelValue"]),
                      (_ctx.paimentNote.statut == 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            style: {"margin-right":"12px"},
                            class: "btn btn-success",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.AddNewColis && _ctx.AddNewColis(...args)))
                          }, " Ajouter "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchTerm1) = $event)),
                          placeholder: "Chercher",
                          type: "text",
                          class: "form-control d-inline-block"
                        }, null, 512), [
                          [_vModelText, _ctx.searchTerm1]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columns,
              rows: _ctx.rows1,
              "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },
              responsive: "",
              "search-options": {
          enabled: true,
          externalQuery: _ctx.searchTerm1,
        },
              onSelectAll: _ctx.onSelectAll,
              onSelectedRowsChange: _ctx.selectionChanged
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("Aucune entrées correspondants trouvés", -1)
                  ])),
                  _: 1,
                  __: [18]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'code')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (props.row.replace == 1)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_13, [
                            _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                            _createVNode(_component_feather_icon, { icon: "RepeatIcon" })
                          ]))
                        : (props.row.partial == 1)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_14, [
                              _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                              _createVNode(_component_feather_icon, { icon: "CornerDownLeftIcon" })
                            ]))
                          : (_openBlock(), _createElementBlock("h6", _hoisted_15, _toDisplayString(props.row.code), 1))
                    ], 64))
                  : (props.column.field === 'status')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              })
                            }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                            }, _toDisplayString(props.row.s_name), 5))
                      ], 64))
                    : (props.column.field === 'price')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                        ], 64))
                      : (props.column.field === 'delivery_time')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            (props.row.delivery_time)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.getDate(props.row.delivery_time)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_17))
                          ], 64))
                        : (props.column.field === 'liv_fees')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              (
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("b", null, _toDisplayString(props.row.liv_fees_livred), 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second == 'REFUSE' &&
                props.row.liv_fees_refused
              )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("b", null, _toDisplayString(props.row.liv_fees_refused), 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (props.column.field === 'total')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                (
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("b", null, _toDisplayString(props.row.price - props.row.liv_fees_livred), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second == 'REFUSE' &&
                props.row.liv_fees_refused
              )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("b", null, _toDisplayString(0 - props.row.liv_fees_refused), 1),
                                      _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (props.column.field === 'action')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-warning btn-icon",
                                    style: {"margin-right":"3px"},
                                    title: "Détails de suivi ",
                                    onClick: ($event: any) => (_ctx.showDetailSuivi(props.row.id))
                                  }, [
                                    _createVNode(_component_feather_icon, { icon: "EyeIcon" })
                                  ], 8, _hoisted_19),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-info btn-icon",
                                    style: {"margin-right":"3px"},
                                    title: "Informations de colis",
                                    onClick: ($event: any) => (_ctx.showDetails(props.row))
                                  }, [
                                    _createVNode(_component_feather_icon, { icon: "InfoIcon" })
                                  ], 8, _hoisted_20)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows", "search-options", "onSelectAll", "onSelectedRowsChange"]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[19] || (_cache[19] = _createElementVNode("label", null, "Voir", -1)),
                _createVNode(_component_v_select, {
                  modelValue: _ctx.users.per_page,
                  "onUpdate:modelValue": [
                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.users.per_page) = $event)),
                    _cache[5] || (_cache[5] = ($event: any) => (_ctx.getRows1()))
                  ],
                  options: [10, 25, 50, 100],
                  clearable: false,
                  class: "per-page-selector d-inline-block mx-50"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", null, "de " + _toDisplayString(_ctx.users.total) + " entités", 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_PaginatorContent, {
                  pagination: _ctx.users,
                  offset: 9,
                  onPaginate: _ctx.getRows1
                }, null, 8, ["pagination", "onPaginate"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_25, [
      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "card-header pb-2" }, [
        _createElementVNode("h5", null, "List des colis ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            (_ctx.auth.can('ADD_BP_L'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", null, "Voir", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.users1.per_page,
                    "onUpdate:modelValue": [
                      _cache[6] || (_cache[6] = ($event: any) => ((_ctx.users1.per_page) = $event)),
                      _cache[7] || (_cache[7] = ($event: any) => (_ctx.getRows2()))
                    ],
                    options: [10, 25, 50, 100],
                    clearable: false,
                    class: "per-page-selector d-inline-block mx-50"
                  }, null, 8, ["modelValue"]),
                  (_ctx.paimentNote.statut == 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        style: {"margin-right":"12px"},
                        class: "btn btn-danger",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.RemoveNewColis && _ctx.RemoveNewColis(...args)))
                      }, " Supprimer "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchTerm2) = $event)),
                      placeholder: "Chercher",
                      type: "text",
                      class: "form-control d-inline-block"
                    }, null, 512), [
                      [_vModelText, _ctx.searchTerm2]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows2,
          "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },
          responsive: "",
          "search-options": {
          enabled: true,
          externalQuery: _ctx.searchTerm2,
        },
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [22]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_34, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _createVNode(_component_feather_icon, { icon: "RepeatIcon" })
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_35, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _createVNode(_component_feather_icon, { icon: "CornerDownLeftIcon" })
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_36, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': _ctx.ColorStatu(props.row.status_second) })
                        }, _toDisplayString(_ctx.resolveStatuParcel(props.row.status_second)), 5))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                      style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                    }, _toDisplayString(props.row.s_name), 5)
                  ], 64))
                : (props.column.field === 'price')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                    ], 64))
                  : (props.column.field === 'delivery_time')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (props.row.delivery_time)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.getDate(props.row.delivery_time)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_38))
                      ], 64))
                    : (props.column.field === 'liv_fees')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          (
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("b", null, _toDisplayString(props.row.liv_fees_livred), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (props.row.status == 'REFUSE' && props.row.liv_fees_refused)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("b", null, _toDisplayString(props.row.liv_fees_refused), 1),
                                _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (props.column.field === 'total')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            (
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("b", null, _toDisplayString(props.row.price - props.row.liv_fees_livred), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            (props.row.status == 'REFUSE' && props.row.liv_fees_refused)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("b", null, _toDisplayString(0 - props.row.liv_fees_refused), 1),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (props.column.field === 'action')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-warning btn-icon",
                                style: {"margin-right":"3px"},
                                title: "Détails de suivi ",
                                onClick: ($event: any) => (_ctx.showDetailSuivi(props.row.id))
                              }, [
                                _createVNode(_component_feather_icon, { icon: "EyeIcon" })
                              ], 8, _hoisted_40),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-info btn-icon",
                                style: {"margin-right":"3px"},
                                title: "Informations de colis",
                                onClick: ($event: any) => (_ctx.showDetails(props.row))
                              }, [
                                _createVNode(_component_feather_icon, { icon: "InfoIcon" })
                              ], 8, _hoisted_41)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "search-options", "onSelectAll", "onSelectedRowsChange"]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _cache[23] || (_cache[23] = _createElementVNode("label", null, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.users1.per_page,
              "onUpdate:modelValue": [
                _cache[10] || (_cache[10] = ($event: any) => ((_ctx.users1.per_page) = $event)),
                _cache[11] || (_cache[11] = ($event: any) => (_ctx.getRows2()))
              ],
              options: [10, 25, 50, 100],
              clearable: false,
              class: "per-page-selector d-inline-block mx-50"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, "de " + _toDisplayString(_ctx.users1.total) + " entités", 1)
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_PaginatorContent, {
              pagination: _ctx.users1,
              offset: 9,
              onPaginate: _ctx.getRows2
            }, null, 8, ["pagination", "onPaginate"])
          ])
        ])
      ])
    ])
  ], 64))
}